import React from "react";

const ChannelIcon = () => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5834 1.55554L9.0278 6.41665H7.63892L2.08336 1.55554M1.38892 6.41665H15.2778V15.4444H1.38892V6.41665Z"
        stroke="#BF740A"
        strokeWidth="1.38889"
      />
    </svg>
  );
};

export default ChannelIcon;
